import { actionType } from '../actions/company';
import baseInitState from '../baseInitState';
import baseReducer from '../baseReducer';

const initState = {
  ...baseInitState,
};

export default function company(state = initState, action) {
  switch (action.type) {
    default:
      return baseReducer(state, action, actionType);
  }
}
